import React, { useState } from 'react';

const ProductNormalExtraScheme = () => {
  const [selectedDivision, setSelectedDivision] = useState('-1');
  const [selectedProduct, setSelectedProduct] = useState('-1');
  
  // Sample divisions data
  const divisions = [
    { value: '4', name: 'COSMACIA' },
    { value: '7', name: 'ESENCIA HC' },
    { value: '8', name: 'ESENCIA WL' },
    { value: '2', name: 'HEALTHCARE' },
    { value: '6', name: 'KPKB' },
    { value: '1', name: 'LHL' },
    { value: '5', name: 'OTC' },
    { value: '3', name: 'WELLNESS' }
  ];

  // Sample products data (would normally come from API based on selected division)
  const products = [
    { value: '1', name: 'Product A' },
    { value: '2', name: 'Product B' },
    { value: '3', name: 'Product C' },
  ];

  const handleSearch = () => {
    // Handle search functionality here
    console.log('Searching for division:', selectedDivision, 'product:', selectedProduct);
  };

  const handlePrint = () => {
    // Handle print functionality here
    window.print();
  };

  const handleExportExcel = () => {
    // Handle Excel export functionality here
    console.log('Exporting to Excel');
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <fieldset className="border p-4 rounded-lg bg-white shadow-sm">
        <legend className="text-lg font-bold text-blue-800 px-2">Product Normal and Extra Scheme</legend>
        
        <div className="my-4 text-center">
          <button className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
            Add Scheme
          </button>
          <hr className="my-4 border-gray-300" />
        </div>

        {/* Search Panel */}
        <div className="mb-6 border rounded-lg p-4 bg-gray-50">
          <fieldset>
            <legend className="text-lg font-semibold px-2">Select Division</legend>
            
            <div className="mt-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Division</label>
                  <select
                    value={selectedDivision}
                    onChange={(e) => setSelectedDivision(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="-1">Select</option>
                    {divisions.map((division) => (
                      <option key={division.value} value={division.value}>
                        {division.name}
                      </option>
                    ))}
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Product</label>
                  <select
                    value={selectedProduct}
                    onChange={(e) => setSelectedProduct(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="-1">Select</option>
                    {products.map((product) => (
                      <option key={product.value} value={product.value}>
                        {product.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              
              <div className="mt-6 text-center">
                <button
                  onClick={handleSearch}
                  className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded"
                >
                  Go
                </button>
              </div>
            </div>
          </fieldset>
        </div>

        {/* Active Scheme Table */}
        <div className="mb-6">
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300">
              <caption className="caption-top py-2 font-bold text-green-600 text-lg">
                Active Scheme
              </caption>
              <tbody>
                <tr>
                  <td colSpan="7" className="p-0">
                    <div className="bg-gray-100 p-4 text-center">
                      Data Not Found. Try Another Search.
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 mt-6">
          <button
            onClick={handlePrint}
            className="flex items-center gap-2 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2z" />
            </svg>
            Print
          </button>
          
          <button
            onClick={handleExportExcel}
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Excel Export
          </button>
        </div>
      </fieldset>
    </div>
  );
};

export default ProductNormalExtraScheme;